require('./brokerRiskInformationBox.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const classNames = require('classnames');

function RiskBlock( {selected, minValue, maxValue } ) {
    const content = [1, 2, 3, 4, 5, 6, 7]
        .filter( pos => pos >= minValue & pos <= maxValue)
        .map( i => <span className="broker-risk-information-box-risk-table__risk-number" key={i}>{i}</span>);
    const customElementClass = classNames(
        'broker-risk-information-box-risk-table__risk-block',
        {
            'broker-risk-information-box-risk-table__risk-block--selected': selected
        }
    );

    return (
        !!content ? <div className={customElementClass}> {content} </div>: null
    );
}

RiskBlock.propTypes = {
    selected: PropTypes.bool,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
}

RiskBlock.defaultProps = {
    selected: false,
    minValue: 1,
    maxValue: 7,
}

module.exports = RiskBlock;
